<div class="flex-row flex-justify-center strategy-header">
  <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
    <span *ngIf="!isEve2">{{ 'new_strategy.navigation.step' | translate }} 2</span>
    <h1 class="ui-headline">
      {{ 'new_strategy.investment_screen.h2' | translate }}
    </h1>
    <p *ngIf="currentAccount.step_status !== 5">{{ 'new_strategy.investment_screen.p' | translate }}</p>
  </div>
</div>

<div class="flex-row flex-justify-center">
  <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
    <div class="white-box">
      <h4>{{ 'new_strategy.risk_screen.input1' | translate }}</h4>
      <div class="investment-input" [class.investment-edit]="currentAccount.step_status === 5">
        {{ currentAccount.currency }}
        <input
          data-cy="input-initial"
          [disabled]="currentAccount.step_status === 5"
          #initialInput
          type="text"
          pattern="\d*"
          min="0"
          step="1"
          maxlength="13"
          [value]="initialInput.type === 'number' ? initialInvestment : (initialInvestment | translateNumber: customer.language)"
          (keydown)="checkNumberValidChars($event)"
          (keyup)="updateInvestment('initial', $event.target.value)"
          (focus)="initialInput.type = 'number'"
          (focusout)="initialInput.type = 'text'; evaluate('initial', $event.target.value)"
        />
      </div>
      <div class="flex-row" *ngIf="currentAccount.step_status !== 5">
        <div
          *ngFor="let initialOption of initialOptions"
          (click)="updateInvestment('initial', initialOption)"
          class="snippet"
          [ngClass]="{ active: initialInvestment === initialOption }"
        >
          {{ initialOption | translateNumber: customer.language : currentAccount.currency }}
        </div>
        <div
          class="snippet"
          [ngClass]="{ active: otherInvestment('initial', initialInvestment) }"
          (click)="initialInput.focus(); updateInvestment('initial', 0)"
        >
          {{ 'new_strategy.risk_screen.other' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="flex-row flex-justify-center">
  <div class="flex-col-4 flex-col-md-6 flex-col-sm-12">
    <div class="white-box">
      <app-ui-tooltip
        [content]="'steps.id5.account_funded.tooltip_month' | translate"
        color="yellow"
        size="small"
        (mouseenter)="trackTooltip('monthly')"
      ></app-ui-tooltip>
      <h4>{{ 'new_strategy.risk_screen.input2' | translate }}</h4>
      <div class="investment-input">
        {{ currentAccount.currency }}
        <input
          #monthlyInput
          data-cy="input-savings"
          type="text"
          pattern="\d*"
          min="0"
          maxlength="13"
          [value]="monthlyInput.type === 'number' ? monthlyInvestment : (monthlyInvestment | translateNumber: customer.language)"
          (keydown)="checkNumberValidChars($event)"
          (keyup)="updateInvestment('monthly', $event.target.value)"
          (focus)="monthlyInput.type = 'number'"
          (focusout)="monthlyInput.type = 'text'; evaluate('monthly', $event.target.value)"
        />
      </div>
      <div class="flex-row">
        <div
          *ngFor="let monthlyOption of monthlyOptions | slice: 1"
          (click)="updateInvestment('monthly', monthlyOption)"
          class="snippet"
          [ngClass]="{ active: monthlyInvestment === monthlyOption }"
        >
          {{ monthlyOption | translateNumber: customer.language : currentAccount.currency }}
        </div>
        <div
          class="snippet"
          [ngClass]="{ active: !monthlyOptions.includes(monthlyInvestment) }"
          (click)="monthlyInput.focus(); updateInvestment('monthly', '')"
        >
          {{ 'new_strategy.risk_screen.other' | translate }}
        </div>
        <div class="snippet" [ngClass]="{ active: monthlyInvestment === 0 }" (click)="monthlyInput.focus(); updateInvestment('monthly', '0')">
          {{ 'new_strategy.risk_screen.noSavings' | translate }}
        </div>
      </div>
      <ng-container *ngIf="error">
        <p class="error">
          {{
            'invest.reg_min_4'
              | translate
                : {
                    initial: minimumInitial | translateNumber: customer.language : currentAccount.currency,
                    monthly: minimumMonthly | translateNumber: customer.language : currentAccount.currency
                  }
          }}
        </p>
      </ng-container>
    </div>
  </div>
</div>

<app-footer [hideGuarantee]="false">
  <ng-container *ngIf="isEve2; else nonEve2">
    <ng-container>
      <button (click)="submitInvestment()" class="ui-button" [class.loading]="isLoading" [disabled]="error">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.investment_screen.cta' | translate }}
      </button>
    </ng-container>
  </ng-container>
  <ng-template #nonEve2>
    <ng-container *ngIf="currentAccount.step_status !== 1 && wasChanged">
      <button (click)="cancelChanges()" class="ui-button secondary" [disabled]="isLoading">
        {{ 'new_strategy.save_mode.cancel' | translate }}
      </button>
      <button (click)="send(true)" class="ui-button" [class.loading]="isLoading" [disabled]="error">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.save_mode.cta' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="currentAccount.step_status !== 1 && !wasChanged">
      <button (click)="cancelChanges()" class="ui-button">
        {{ 'new_strategy.portfolio_screen.back_cta' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="currentAccount.step_status === 1">
      <button (click)="send()" class="ui-button" [class.loading]="isLoading" [disabled]="error">
        <span class="icon-i-windmill"></span>
        {{ 'new_strategy.investment_screen.cta' | translate }}
      </button>
    </ng-container>
  </ng-template>
</app-footer>

<app-strategy-was-changed-modal
  (saveChangesEmitter)="send($event)"
  [stepStatus]="currentAccount?.step_status"
  [qlOnboardingStep]="currentAccount?.ql_onboarding_step"
></app-strategy-was-changed-modal>
